import { Link } from "react-router-dom";
import { useState } from "react";
import './NavBar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell,faUserMinus,faUserEdit,faMoneyCheckAlt,faChartPie,faHandHoldingDollar,faPauseCircle } from '@fortawesome/free-solid-svg-icons'

function NavBar(){  
    return <>
            <div className="NavWhole">
              <div className="Logo">
                 <li>            
                  <Link to="/" className="textLink"><h1><i>Nerday</i></h1></Link>
                </li>
              </div>
              <div className="NavLinks">
              <ul > 
                  <li><Link to="/" className="textLink"><FontAwesomeIcon icon={faBell} /></Link></li>
                  {/* <li><Link to="/about" className="textLink"><i class="material-icons prefix">question_answer </i></Link></li>
                  <li><Link to="/about" className="textLink"><i class="material-icons prefix">menu </i></Link></li> */}
                </ul>
              </div>
                
            </div>  
            
            
            
          </>

}

export default NavBar;